import type { LucideIcon } from 'lucide-react';
import {
  Home,
  BookOpen,
  CalendarDays,
  UserRound,
  GraduationCap,
  ClipboardCheck,
  ClipboardList,
  UsersRound,
  Settings,
  BarChart3,
  Inbox,
  Building2,
  MessagesSquare,
  FilePenLine,
  FlaskConical,
} from 'lucide-react';
import type { Role } from './types';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export const NAV: Record<Role, NavItem[]> = {
  mahasiswa: [
    { to: '/app/mahasiswa', label: 'Beranda', icon: Home },
    { to: '/app/mahasiswa/skripsi', label: 'Skripsi', icon: GraduationCap },
    { to: '/app/mahasiswa/bimbingan', label: 'Bimbingan', icon: BookOpen },
    { to: '/app/mahasiswa/profil', label: 'Profil', icon: UserRound },
  ],
  dosen: [
    { to: '/app/dosen', label: 'Beranda', icon: Home },
    { to: '/app/dosen/skripsi', label: 'Skripsi', icon: GraduationCap },
    { to: '/app/dosen/pengajuan', label: 'Pengajuan', icon: FilePenLine },
    { to: '/app/dosen/bimbingan', label: 'Bimbingan', icon: BookOpen },
    { to: '/app/dosen/konsultasi', label: 'Konsultasi', icon: MessagesSquare },
    { to: '/app/dosen/jadwal', label: 'Jadwal', icon: CalendarDays },
    { to: '/app/dosen/permintaan', label: 'Permintaan', icon: Inbox },
    { to: '/app/dosen/rekap', label: 'Rekap Prodi', icon: BarChart3 },
    { to: '/app/dosen/profil', label: 'Profil', icon: UserRound },
  ],
  staf_jurusan: [
    { to: '/app/staf_jurusan', label: 'Beranda', icon: Home },
    { to: '/app/staf_jurusan/verifikasi', label: 'Verifikasi', icon: ClipboardCheck },
    { to: '/app/staf_jurusan/persyaratan', label: 'Persyaratan', icon: ClipboardList },
    { to: '/app/staf_jurusan/jadwal', label: 'Jadwal', icon: CalendarDays },
    { to: '/app/staf_jurusan/data', label: 'Data', icon: UsersRound },
    { to: '/app/staf_jurusan/profil', label: 'Profil', icon: UserRound },
  ],
  staf_fakultas: [
    { to: '/app/staf_fakultas', label: 'Beranda', icon: Home },
    { to: '/app/staf_fakultas/laporan', label: 'Laporan', icon: BarChart3 },
    { to: '/app/staf_fakultas/organisasi', label: 'Organisasi', icon: Building2 },
    { to: '/app/staf_fakultas/persyaratan', label: 'Persyaratan', icon: ClipboardList },
    { to: '/app/staf_fakultas/verifikasi', label: 'Verifikasi', icon: Inbox },
    { to: '/app/staf_fakultas/data', label: 'Data', icon: UsersRound },
    { to: '/app/staf_fakultas/profil', label: 'Profil', icon: UserRound },
  ],
  admin: [
    { to: '/app/admin', label: 'Beranda', icon: Home },
    { to: '/app/admin/pengguna', label: 'Pengguna', icon: UsersRound },
    { to: '/app/admin/organisasi', label: 'Organisasi', icon: Building2 },
    { to: '/app/admin/data', label: 'Skripsi', icon: GraduationCap },
    { to: '/app/admin/persyaratan', label: 'Persyaratan', icon: ClipboardList },
    { to: '/app/admin/pengaturan', label: 'Aturan', icon: Settings },
    { to: '/app/admin/seed', label: 'Data Demo', icon: FlaskConical },
    { to: '/app/admin/profil', label: 'Profil', icon: UserRound },
  ],
};
